import { useState, type ReactNode } from 'react';
import type { Locale } from './translations';
import { defaultLocale } from './translations';
import { LocaleContext } from './context';

const LOCALE_STORAGE_KEY = 'kyykka-locale';

function getInitialLocale(): Locale {
  // Check localStorage for user preference, otherwise default to Finnish
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored === 'fi-FI' || stored === 'en-US') {
      return stored;
    }
  }

  // Default to Finnish (this is a Finnish event)
  return defaultLocale;
}

interface LocaleProviderProps {
  children: ReactNode;
}

export function LocaleProvider({ children }: LocaleProviderProps) {
  const [locale, setLocaleState] = useState<Locale>(getInitialLocale);

  const setLocale = (newLocale: Locale) => {
    setLocaleState(newLocale);
    localStorage.setItem(LOCALE_STORAGE_KEY, newLocale);
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
}

